import React, { useState, useEffect } from "react";
import { useHooksSubsidiary } from "../../../hooks";
import swal from "sweetalert2";

const initialState = {
    id: 0,
    name: "",
    serial: "",
    ruc: "",
    business: "",
    phone: "",
    address: "",
};

const inputClass =
    "w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors";
const labelClass =
    "block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mb-1";

export function FragmentAddEditSubsidiary({ onRefetch, subsidiary, onClose }) {
    const { addSubsidiary, updateSubsidiary } = useHooksSubsidiary();
    const [itemSubsidiary, setItemSubsidiary] = useState(initialState);
    useEffect(() => {
        if (subsidiary.id === undefined || subsidiary.id === 0) {
            setItemSubsidiary(initialState);
        } else {
            setItemSubsidiary(subsidiary);
        }
    }, [subsidiary]);

    const handleChange = (e) => {
        const { target } = e;
        const { name, value } = target;
        const newValues = {
            ...itemSubsidiary,
            [name]: value,
        };
        setItemSubsidiary(newValues);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (e.target.serial.value === "") {
            swal.fire({
                icon: "error",
                title: "Ups...",
                text: "Ingrese un numero de serie!",
            });
            return false;
        }
        if (e.target.name.value === "") {
            swal.fire({
                icon: "error",
                title: "Ups...",
                text: "Ingrese el nombre de la sede",
            });
            return false;
        }
        if (e.target.ruc.value === "") {
            swal.fire({
                icon: "error",
                title: "Ups...",
                text: "Ingrese el numero de RUC",
            });
            return false;
        }
        if (e.target.business.value === "") {
            swal.fire({
                icon: "error",
                title: "Ups...",
                text: "Ingrese la razon social de la sede",
            });
            return false;
        }
        try {
            if (subsidiary.id === undefined || subsidiary.id === 0) {
                await addSubsidiary(itemSubsidiary);
                swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Sede registrada correctamente",
                    showConfirmButton: false,
                    timer: 1500,
                });
            } else {
                await updateSubsidiary(itemSubsidiary);
                swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Sede actualizada correctamente",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
            onClose();
            onRefetch();
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <form id="form-person" onSubmit={handleSubmit}>
            <div className="space-y-4 px-6 py-5">
                <div className="grid grid-cols-1 sm:grid-cols-12 gap-4">
                    <div className="sm:col-span-3">
                        <label htmlFor="serial" className={labelClass}>
                            Serie
                        </label>
                        <input
                            type="text"
                            id="serial"
                            className={inputClass}
                            name="serial"
                            maxLength={4}
                            value={itemSubsidiary.serial}
                            onChange={handleChange}
                            placeholder="Serie Sede"
                        />
                    </div>
                    <div className="sm:col-span-9">
                        <label htmlFor="name" className={labelClass}>
                            Nombre Sede
                        </label>
                        <input
                            type="text"
                            id="name"
                            className={inputClass}
                            name="name"
                            maxLength={100}
                            value={itemSubsidiary.name}
                            onChange={handleChange}
                            placeholder="Nombre Sede"
                        />
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-12 gap-4">
                    <div className="sm:col-span-3">
                        <label htmlFor="ruc" className={labelClass}>
                            Ruc
                        </label>
                        <input
                            type="text"
                            id="ruc"
                            className={inputClass}
                            name="ruc"
                            maxLength={11}
                            value={itemSubsidiary.ruc}
                            onChange={handleChange}
                            placeholder="Numero Ruc"
                        />
                    </div>
                    <div className="sm:col-span-9">
                        <label htmlFor="business" className={labelClass}>
                            Razón Social
                        </label>
                        <input
                            type="text"
                            id="business"
                            className={inputClass}
                            name="business"
                            maxLength={200}
                            value={itemSubsidiary.business}
                            onChange={handleChange}
                            placeholder="Razón Social"
                        />
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-12 gap-4">
                    <div className="sm:col-span-3">
                        <label htmlFor="phone" className={labelClass}>
                            Teléfono
                        </label>
                        <input
                            type="text"
                            id="phone"
                            className={inputClass}
                            name="phone"
                            maxLength={9}
                            value={itemSubsidiary.phone}
                            onChange={handleChange}
                            placeholder="Teléfono"
                        />
                    </div>
                    <div className="sm:col-span-9">
                        <label htmlFor="address" className={labelClass}>
                            Dirección
                        </label>
                        <input
                            type="text"
                            id="address"
                            className={inputClass}
                            name="address"
                            maxLength={200}
                            value={itemSubsidiary.address}
                            onChange={handleChange}
                            placeholder="Dirección"
                        />
                    </div>
                </div>

                <div className="pt-3">
                    <button
                        type="submit"
                        className="w-full inline-flex items-center justify-center gap-1.5 rounded-lg bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white text-sm font-medium px-4 py-2 transition-colors focus:outline-none focus:ring-2 focus:ring-emerald-500"
                    >
                        <i className="fas fa-check-circle"></i>
                        {subsidiary.id
                            ? "Actualizar Sucursal"
                            : "Registrar Sucursal"}
                    </button>
                </div>
            </div>
        </form>
    );
}
